import { Input as TextInput2 } from "./TextInput2";

export {
    TextInput2 as default,
};
